/** Detect diary-quota failures stored on quickstarts.error_message after webhook processing. */
export function isDiaryQuotaQuickstartError(errorMessage: string | null | undefined): boolean {
    if (!errorMessage) return false;
    return errorMessage.includes("DIARY_QUOTA_EXCEEDED") || errorMessage.includes("DIARY_QUOTA_OWNER_UNRESOLVED");
}
